// Translator notes: The emphatic subject pronoun kept (engine/src/subject-emphasis.ts).
// Each id is an engine note (`notes.add(text, id, args)`); `args` names its arguments in the order the
// strings take them. Collected by translator/notes.ts (import.meta.glob): adding a note means adding it here.
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  pronounEmphasis: {
    args: ['word'],
    fi: (a: string[]) =>
      `Subjekti on painotettu, joten pronomini ${a[0]} pidettiin mukana. Tavallisesti se jätetään pois, koska verbin pääte kertoo persoonan (oppitunnit 37 ja 47).`,
    en: (a: string[]) =>
      `The subject is emphasised, so the pronoun ${a[0]} was kept. Usually it is left out, because the verb ending shows the person (lessons 37 and 47).`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
